export const options = {
    responsive: true,
    scales: { x: { stacked: true }, y: { stacked: true } },
    plugins: {
        zoom: {
            pan: {
                enabled: true,
                mode: 'x',
                modifierKey: 'ctrl',
            },
            zoom: {
                drag: {
                    enabled: true,
                },
                wheel: {
                    enabled: true,
                    speed: 0.5,
                    modifierKey: 'ctrl',
                },
                pinch: {
                    enabled: true,
                },
                mode: 'x',
            },
        },
    },
};
export const optionsLinear = {
    responsive: true,
    plugins: {
        zoom: {
            pan: {
                enabled: true,
                mode: 'x',
                modifierKey: 'ctrl',
            },
            zoom: {
                drag: {
                    enabled: true,
                },
                wheel: {
                    enabled: true,
                    speed: 0.5,
                    modifierKey: 'ctrl',
                },
                pinch: {
                    enabled: true,
                },
                mode: 'x',
            },
        },
    },
};
